import React, { useState, useEffect } from "react";
import PolyProps from "./PolyPropss"; // Updated to match existing file name
import pp from "../../assets/pp.png";
import pc1 from "../../assets/pc1.png";
import pc2 from "../../assets/pc2.png";
import flagPakistan from "../../assets/pakistan.png";
import flagJapan from "../../assets/japan.png";
import flagSaudiArabia from "../../assets/saudi_arabia.png";
import flagNorway from "../../assets/norway.png";
import flagUAE from "../../assets/united_arab_emirates.png";
import flagUSA from "../../assets/united_states_of_america.png";
import s1age4 from "../../assets/s1age4.png";
import s1age7 from "../../assets/s1age7.png";
import s1age11 from "../../assets/s1age11.png";
// import s2age4 from "../../assets/s2age4.png";
import s2age7 from "../../assets/s2age7.png";
// import s2age11 from "../../assets/s2age11.png";
// import s3age4 from "../../assets/s3age4.png";
// import s3age7 from "../../assets/s3age7.png";
// import s3age11 from "../../assets/s3age11.png";
import axios from 'axios';

const IQCompetition = () => {
  const [competitionData, setCompetitionData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch competition data from database
  useEffect(() => {
    const fetchCompetitionData = async () => {
      try {
        const response = await axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/allpolymatchcompetition`);
        if (response.data && response.data.length > 0) {
          // Filter competitions that contain "iq" or "logic" in the name (case insensitive)
          const iqCompetitions = response.data.filter(comp => 
            comp.Competition_Name && (
              comp.Competition_Name.toLowerCase().includes('iq') ||
              comp.Competition_Name.toLowerCase().includes('logic')
            )
          );
          console.log("IQ Competitions:", iqCompetitions);
          setCompetitionData(iqCompetitions);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching competition data:', error);
        setLoading(false);
      }
    };

    fetchCompetitionData();
  }, []);

  const headerSection = {
    mainHeading: "IQ & Logic Competition",
    // subHeading: "2025",
    mainImage: pp,
    leftImage: pc1,
    rightImage: pc2,
  };

  const upcomingCompetitionSection = {
    mainHeading: "For Our Upcoming Competition",
    subHeading: "Stay Tuned",
    competitionName: "IQ & Logic Competition",
    description:
      "The PolyMatch Global IQ & Logic Competition fuels young minds with curiosity, creativity, and the thrill of problem-solving. This dynamic event unites participants from around the world to explore engaging challenges in logic, reasoning, mathematics, and scientific thinking. Designed for ages 4–16, the competition nurtures critical thinking, sharpens analytical skills, and fosters a love for discovery in an interactive, gamified environment. With opportunities to connect globally, celebrate achievements, and earn prestigious awards, it’s more than a competition — it’s a journey into the exciting world of intelligence and innovation.",
    registerLink: "/PolymatchReg",
    flags: [
      { src: flagPakistan, alt: "Pakistan Flag" },
      { src: flagJapan, alt: "Japan Flag" },
      { src: flagSaudiArabia, alt: "Saudi Arabia Flag" },
      { src: flagNorway, alt: "Norway Flag" },
      { src: flagUAE, alt: "United Arab Emirates Flag" },
      { src: flagUSA, alt: "United States of America Flag" },
    ],
  };

  // Dynamic competition years section based on database data
  const competitionYearsSection = {
    mainHeading: "IQ & Logic Competition",
    defaultYear: 2025,
    years: competitionData.map(comp => ({
      year: new Date(comp.Competition_date).getFullYear(),
      title: comp.Competition_Name,
      dates: new Date(comp.Competition_date).toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }),
      description: comp.Competition_Description || "The PolyMatch IQ & Knowledge Competition was a huge success, with a big rise in global participation. It was a fun, high-energy event where participants showcased their amazing language skills and passion for learning.",
      competitionId: comp.Competition_Id,
    })),
    flags: [
      { src: flagPakistan, alt: "Pakistan Flag" },
      { src: flagJapan, alt: "Japan Flag" },
      { src: flagSaudiArabia, alt: "Saudi Arabia Flag" },
      { src: flagNorway, alt: "Norway Flag" },
      { src: flagUAE, alt: "United Arab Emirates Flag" },
      { src: flagUSA, alt: "United States of America Flag" },
    ],
  };

  const winnersSection = {
    mainHeading: "Congratulations to All Winners!",
    description:
      "We're proud of every participant, and we applaud the outstanding winners who showcased exceptional skills, creativity, and determination. Your hard work truly shines—well done!",
    winners: [
      {
        year: 2025,
        image: "PolymatchImages/student1.png",
        alt: "Age 4-5 Winner",
        ageCategory: "Ages 4-5",
        studentsData: [
          {
            name: "Isaiah Gill",
            rank: "1st Winner",
            country: "Islamabad, Pakistan",
            age: "4 Years",
            image: 'Polymath-images/Winners Pics/2025/IQ/4 to 5/1stPosition-IsaiahGill.png',
          },
          {
            name: "Meesha Farhan",
            rank: "2nd Winner",
            country: "Islamabad, Pakistan",
            age: "5 Years",
            image: 'Polymath-images/Winners Pics/2025/IQ/4 to 5/2ndPosition-MeeshaFarhan.png',
          },
          {
            name: "Muhammad Umar Arshad",
            rank: "3rd Winner",
            country: "Karachi, Pakistan",
            age: "4 Years",
            image: 'Polymath-images/Winners Pics/2025/IQ/4 to 5/3rdPosition-MohammadUmar.png',
          },
        ],
      },
      {
        year: 2025,
        image: "Polymath-images/Winners Pics/2025/IQ/6 to 8/1stPosition-AabisAbbas.png",
        alt: "Age 6-8 Winner",
        ageCategory: "Ages 6-8",
        studentsData: [
          {
            name: "Muhammad Aabis Abbas",
            rank: "1st Winner",
            country: "Islamabad, Pakistan",
            age: "7 Years",
            image: "Polymath-images/Winners Pics/2025/IQ/6 to 8/1stPosition-AabisAbbas.png",
          },
          {
            name: "Muhammad Usman",
            rank: "2nd Winner",
            country: "Karachi, Pakistan",
            age: "8 Years",
            image: "Polymath-images/Winners Pics/2025/IQ/6 to 8/2ndPosition-UsmanAli.png",
          },
          {
            name: "Muhammad Shees",
            rank: "3rd Winner",
            country: "KarLahore, Pakistan",
            age: "8 Years",
            image: "Polymath-images/Winners Pics/2025/IQ/6 to 8/3rdPosition-MohammadShees.png",
          },
        ],
      },
      {
        year: 2025,
        image: "Polymath-images/Winners Pics/2025/IQ & Logic/9 to 11//student1.png",
        alt: "Age 9-11 Winner",
        ageCategory: "Ages 9-11",
        studentsData: [
          {
            name: "Caleb John Nicolas",
            rank: "1st Winner",
            country: "Philippines",
            age: "11 Years",
            image: "Polymath-images/Winners Pics/2025/IQ/9 to 11/1stPosition-Caleeb.png",
          },
          {
            name: "Mustafa Bin Hasan Zuberi",
            rank: "2nd Winner",
            country: "Lahore, Pakistan",
            age: "11 Years",
            image: "Polymath-images/Winners Pics/2025/IQ/9 to 11/2ndPosition-Mustafa.png",
          },
          {
            name: "Emaan Omer",
            rank: "3rd Winner",
            country: "Islamabad, Pakistan",
            age: "11 Years",
            image: "Polymath-images/Winners Pics/2025/IQ/9 to 11/3rdPosition-EmanOmer.png",
          },
        ],
      },
      {
        year: 2025,
        image: "Polymath-images/Winners Pics/2025/IQ & Logic/12 to 16/student1.png",
        alt: "Age 12-15 Winner",
        ageCategory: "Ages 12-15",
        studentsData: [
          {
            name: "Falah Hamad Sahaf",
            rank: "1st Winner",
            country: "Lahore, Pakistan",
            age: "16 Years",
            image: "Polymath-images/Winners Pics/2025/IQ/12 to 14/1stPosition-FalahHamadSahaf.png",
          },
          {
            name: "Musa Tayyab",
            rank: "2nd Winner",
            country: "Lahore, Pakistan",
            age: "12 Years",
            image: "Polymath-images/Winners Pics/2025/IQ/12 to 14/2ndPosition-MusaTayyab.png",
          },
          {
            name: "Aazim Zia ",
            rank: "3rd Winner",
            country: "Lahore, Pakistan",
            age: "16 Years",
            image: "Polymath-images/Winners Pics/2025/IQ/12 to 14/3rdPosition-AazimZia.png",
          },
        ],
      },
    ],
    resultsLink: "/PolymatchResults_Linguistic",
  };

  const spotlightSection = {
    mainHeading: "Participant Spotlight",
    subHeading: " – Watch Them in Action",
    description:
      "Get inspired by the creativity, confidence, and talent of our young competitors. These videos showcase real moments from PolyMatch participants sharing their experiences, solving linguistic challenges, and celebrating success.",
    participants: [
      {
        name: "Isaiah Gill ",
        compName: "IQ & Logic Competition 2025",
        rank: "1st Winner – Age Category 4 - 5",
        country: "From Pakistan",
        video: "https://www.youtube.com/shorts/wlKLPvtEXb0?si=NtKfCEAQbMNERzbh",
      },
      // {
      //   name: "Emaan Omar",
      //   compName: "English Linguistic Competition 2024",
      //   rank: "3rd Winner – Age Category 9 - 11",
      //   country: "From Pakistan",
      //   video: null,
      // },
      // {
      //   name: "Emaan Omar",
      //   compName: "English Linguistic Competition 2024",
      //   rank: "3rd Winner – Age Category 9 - 11",
      //   country: "From Pakistan",
      //   video: null,
      // },
      // {
      //   name: "Emaan Omar",
      //   compName: "English Linguistic Competition 2024",
      //   rank: "3rd Winner – Age Category 9 - 11",
      //   country: "From Pakistan",
      //   video: null,
      // },
      // {
      //   name: "Emaan Omar",
      //   compName: "English Linguistic Competition 2024",
      //   rank: "3rd Winner – Age Category 9 - 11",
      //   country: "From Pakistan",
      //   video: null,
      // },
      // {
      //   name: "Emaan Omar",
      //   compName: "English Linguistic Competition 2024",
      //   rank: "3rd Winner – Age Category 9 - 11",
      //   country: "From Pakistan",
      //   video: null,
      // },
    ],
  };

  // Show loading state while fetching data
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading competition data...
      </div>
    );
  }

  // Show message if no IQ competitions found
  if (!competitionData || competitionData.length === 0) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        fontSize: '18px',
        color: '#666',
        textAlign: 'center',
        padding: '20px'
      }}>
        <div>
          <h3>No IQ competitions found</h3>
          <p>Please check back later for upcoming IQ competitions.</p>
        </div>
      </div>
    );
  }

  return (
    <PolyProps
      headerSection={headerSection}
      upcomingCompetitionSection={upcomingCompetitionSection}
      competitionYearsSection={competitionYearsSection}
      winnersSection={winnersSection}
      spotlightSection={spotlightSection}
      text={"Upcoming Event: July 2026"}
    />
  );
};

export default IQCompetition;